import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import VideoStoreSelector from '../../../../../Modules/Redux/Global/Video/VideoStoreSelector';
import { MLVideoPlayer } from '../../../Components/MLVideoPlayer/MLVideoPlayer';
import { NoVideoInputMessage } from '../Components/NoVideoInputMessage/NoVideoInputMessage';

export const StreamPageVideo: FunctionComponent = () => {
  const videoSource = useSelector(VideoStoreSelector.videoSource);
  return videoSource ? (
    <div className="h-full w-full aspect-w-16 aspect-h-9 bg-black">
      <MLVideoPlayer />
    </div>
  ) : (
    <div className="h-full p-2 v-stack items-center justify-center">
      <NoVideoInputMessage />
    </div>
  );
};
